import { GenericBridge } from './Bridges/GenericBridge'
import { registerPlugin as registerCapacitorPlugin } from '@capacitor/core'

interface PluginProps {
  identifier: string
}

export const registerPlugin = <
  Bridge extends GenericBridge<Events>,
  Events = {}
>(
  identifier: string
) => {
  return registerCapacitorPlugin<Bridge>(identifier)
}
